import { GET_STRUCT_TOP } from "../../../enums/Request/leader.requests.types";

export const getStructureTopAction = (struct) => {
    return {
        type: GET_STRUCT_TOP,
        payload: struct,
    };
};